<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.0047 11.9998L18.7828 16.7779C19.3369 17.3319 19.3411 18.226 18.7837 18.7834C18.2301 19.337 17.3357 19.3401 16.7781 18.7826L12 14.0045L7.22196 18.7826C6.6679 19.3366 5.77385 19.3409 5.21642 18.7834C4.66285 18.2299 4.65976 17.3354 5.2173 16.7779L9.99539 11.9998L5.2173 7.22171C4.66324 6.66766 4.65899 5.77361 5.21642 5.21618C5.76999 4.6626 6.66442 4.65951 7.22196 5.21705L12 9.99514L16.7781 5.21705C17.3322 4.66299 18.2262 4.65874 18.7837 5.21618C19.3372 5.76975 19.3403 6.66417 18.7828 7.22171L14.0047 11.9998Z"
      fill="#3F3F3F"
    />
  </svg>
</template>
